import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [settings, setSettings] = useState(null);
  const [upgrade, setUpgrade] = useState(null);

  const refreshSettings = useCallback(async () => {
    try { const { data } = await api.get("/settings/public"); setSettings(data); } catch { /* ignore */ }
  }, []);

  const refreshMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refreshMe();
    refreshSettings();
    const onExpired = () => setUser(false);
    window.addEventListener("auth:expired", onExpired);
    return () => window.removeEventListener("auth:expired", onExpired);
  }, [refreshMe, refreshSettings]);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    setUser(data);
  };
  const register = async (username, password) => {
    const { data } = await api.post("/auth/register", { username, password });
    setUser(data);
  };
  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
  };
  const setGrade = async (grade) => {
    const { data } = await api.put("/auth/grade", { grade });
    setUser(data);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, setGrade, refreshMe, settings, refreshSettings, upgrade, openUpgrade: (reason = "") => setUpgrade({ reason }), closeUpgrade: () => setUpgrade(null) }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export const isStaff = (u) => u && (u.role === "admin" || u.role === "moderator");
